import { gql } from '@apollo/client';

export const VERIFY_CHANGE_EMAIL = gql`
  mutation verifyChangeEmail($input: VerifyChangeEmailInput) {
    verifyChangeEmail(input: $input) {
      email
      status
    }
  }
`;
